<blaze-dialog (closeDialog)="closeDialog()" class="duplicate-dialog" [showFooter]="true">
  <div icon class="header-icon">
    <mat-icon svgIcon="icon_copy_to_clipboard_16" class="w-16 h-16 icon-16" />
  </div>

  <div title> Duplicate Table </div>

  <div content class="modal-content">
    <div class="form-field">
      <label>New Table Name</label>
      <input
        [formControl]="tableName"
        [placeholder]="dialogData"
        class="bd-text-input tall mt-8"
        data-cy="ProjectPageEditNameSlugDialog:tableName"
      />
    </div>
    <mat-radio-group
      class="current-row-toggle flex bg-base-light rounded"
      ngDefaultControl
      (change)="linkConditionChanged($event)"
      [value]="!!copyData"
    >
      <mat-radio-button class="items-center cursor-pointer flex-1" [value]="false">
        Header Only
      </mat-radio-button>
      <mat-radio-button class="items-center cursor-pointer flex-1" [value]="true">
        Data & Header
      </mat-radio-button>
    </mat-radio-group>
  </div>

  <div footer class="footer">
    <button
      class="bd-btn bd-btn-primary uppercase"
      (click)="confirm()"
      data-cy="confirmDialog:confirm"
    >
      Duplicate
    </button>
  </div>
</blaze-dialog>
